
import {  apiPost  } from "../http";


export default {
    async checkAspects(body) {
        return await apiPost("api/platformUpload/checkAspects", body);
    },
    async saveAspectOverrides(body) {
        return await apiPost("api/platformUpload/saveAspectOverrides", body);
    },
}